import React from 'react';
import Component from '@vfuk/core-card-list';
const CardList = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CardList;
